import React, { useEffect, useState } from 'react';
import style from './Home.module.css';
const json = require('../../../package.json');

export default function Home() {
  const [ipData, setIpData] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;
    (async () => {
      try {
        const response = await fetch('/api/ip', { signal });
        const data = await response.json();
        setIpData(data);
      } catch (error) {
        console.error('Error fetching IP data:', error);
      }
    })();

    return () => controller.abort();
  }, []);

  return (
    <>
      <div className={style.rowA}>
        <label className={style.section} htmlFor='client-data'>
          Firma transportowa Z.Jaskot
        </label>
      </div>
      <div className={style.rowA2}>
        <label className={style.section} htmlFor='client-data'>
          TransportAPK ver: {json.version}
        </label>
      </div>
      <div className={style.footer}>
        <label className={style.section} htmlFor='client-data'>
          Server IP: {ipData ? ipData.ip : 'Ładowanie...'}
        </label>
      </div>
    </>
  );
}
